const e = {
  name: "FoodAndBeverage",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 10V2H2V10C2 11.6523 3.34772 13 5 13H6V22H8V13H9C10.6523 13 12 11.6523 12 10V2H10V10C10 10.5477 9.54772 11 9 11H5C4.45228 11 4 10.5477 4 10Z" fill="currentColor"/>
<path d="M8 9V2H6V9H8Z" fill="currentColor"/>
<path d="M21 2C17.6877 2 15 4.68772 15 8V14C15 15.6523 16.3477 17 18 17H20V22H22V2H21ZM20 4.12623V15H18C17.4523 15 17 14.5477 17 14V8C17 6.13753 18.2756 4.57072 20 4.12623Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as FoodAndBeverage
};
